import { render, staticRenderFns } from "./newGallery.vue?vue&type=template&id=b0c3a81a&scoped=true"
import script from "./newGallery.vue?vue&type=script&lang=js"
export * from "./newGallery.vue?vue&type=script&lang=js"
import style0 from "./newGallery.vue?vue&type=style&index=0&id=b0c3a81a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c3a81a",
  null
  
)

export default component.exports